import { apiClient } from "@vv/api";
import type { AnalyticsSummary, TeamAnalytics } from "../domain/analytics.types";

export const analyticsApi = {
  summary: (teamId?: string) =>
    apiClient.get<AnalyticsSummary>(`/analytics/summary${teamId ? `?teamId=${teamId}` : ""}`),
  byTeam: () => apiClient.get<TeamAnalytics[]>("/analytics/by-team"),
};
